define.alias("ember-composable-helpers/helpers/pick", "media/helpers/pick");